import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@fiverr-private/fit';
import './style.scss';

const Footer = ({ buttonTextStay, buttonTextLeave, onClickStay, onClickLeave }) => (
    <footer className="modal-want-to-leave-footer font-accent">
        {buttonTextLeave && <Button className="leave-button" fill="ghost" color="grey" onClick={onClickLeave}>{buttonTextLeave}</Button>}
        {buttonTextStay && <Button onClick={onClickStay}>{buttonTextStay}</Button>}
    </footer>
);

Footer.propTypes = {
    buttonTextStay: PropTypes.string,
    buttonTextLeave: PropTypes.string,
    onClickStay: PropTypes.func,
    onClickLeave: PropTypes.func
};

export default Footer;
